<template>
  <div class="home-page">
    <!-- Hero Section -->
    <section class="hero-section">
      <div class="hero-content">
        <h1>Learn. Innovate. Transform.</h1>
        <p>
         Azadi Academy is your destination to becoming a crypto and blockchain expert.
        </p>
        <div class="view-courses-btn-sec">
          <button class="view-courses-btn" @click="handleRoute('/category')">View Tutorials</button>
        </div>
      </div>
    </section>

    <!-- Certification Benefits Section -->
    <section class="benefits-section">
      <h2>How Will Our Certification Benefit You?</h2>
      <div class="courses-grid skill-grid">
        <SkillsCard v-for="(skill, i) in skills" :key="i"
            :iconSrc="skill.iconSrc"
            :title="skill.title"
            :description="skill.description"
          />
      </div>
    </section>

    <!-- Recent Courses Section -->
    <section class="courses-section">
      <h2>Our Recent Tutorials</h2>
      <div class="courses-grid">
        <div v-for="course in courses" :key="course.id" class="course-card" @click="handleRoute('/course-detail/'+course.id)">
          <img :src="course.course_image" alt="course image" class="course-image" />
          <div class="course-details">
            <h4>{{ course.name }}</h4>
            <p class="duration">
              {{ course.duration }} minutes <span class="ml-2"> ● {{ course.certification }} </span>
            </p>
            <p class="price" v-if="course.payment_option != 'free'">{{ course.price }} Azadi Coin (AC)</p>
            <p class="price" v-else>FREE</p>
          </div>
          <router-link :to="'/course-detail/'+course.id"
          ><button class="enroll-btn">Enroll Now</button></router-link
          >
        </div>
      </div>
      <router-link :to="'/category'" >
        <button class="view-more-courses-btn">View Tutorials</button>
      </router-link>
    </section>
  </div>
</template>

<script>
import axios from 'axios';
import SkillsCard from './SkillsCard.vue';
export default {
  components: {
    SkillsCard
  },
  data() {
    return {
      courses: [],
      skills: [
        {
          "iconSrc": "lightbulb.png",
          "title": "Practical Skills",
          "description": "Essential Skills for Navigating Blockchain and Crypto."
        },
        {
          "iconSrc": "lock_check.png",
          "title": "Lifetime Course Access",
          "description": "Enjoy unlimited access to all course materials."
        },
        {
          "iconSrc": "certificate.png",
          "title": "Lifetime Certification Validity",
          "description": "Your certification is valid for life, showcasing your expertise forever."
        },
        {
          "iconSrc": "growth.png",
          "title": "Career Advancement",
          "description": "Boost your career with new skills and opportunities for growth."
        },
        {
          "iconSrc": "support.png",
          "title": "24/7 Support",
          "description": "Get assistance whenever you need it, anytime, day or night."
        },
        {
          "iconSrc": "badge.png",
          "title": "Certified Professional",
          "description": "Stand out as a recognised expert with our certified professional badge."
        }
      ]
    };
  },
  mounted() {
    this.courseList();
  },
  methods: {
    handleRoute(route) {
      this.$router.push(route)
    },
    async courseList() {
      try {
        const response = await axios.get("courses");
        this.courses = (response.data.data || []).slice(0, 4);
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style scoped>
/* Hero Section */
.hero-section {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #121E4A;
  padding: 5rem;
  color: #fff;
  min-height: calc(100vh - 112px);
}

.hero-content {
  max-width: 850px;
  text-align: center;
  z-index: 1;
  margin-bottom: 60px;
}

.hero-content h1 {
  font-size: 3.2rem;
  margin-bottom: 2rem;
  font-family: Bebas;
  color: #f0c57a;
  font-weight: 800;
}

.view-courses-btn-sec {
  display: flex;
  justify-content: center;
}

.hero-content p {
  color: #fff;
  margin-bottom: 3rem;
  font-family: "GothicB";
  font-size: 1.2rem;
  text-align: center;
  /* max-width: 90%; */
  margin-left: auto;
  margin-right: auto;
  letter-spacing: 1px;
  line-height: 1.6rem;
}

.view-courses-btn {
  background-color: #f0ba7c;
  font-family: Gothic;
  color: #000;
  border: 1px solid #f0ba7c;
  outline: none;
  border-radius: 0.5rem;
  font-weight: 700;
  font-size: 1.2rem;
  padding: 0.6rem 2rem;
}

.hero-img {
  width: 200px;
  height: auto;
  border-radius: 5px;
}

/* Benefits Section */
.benefits-section {
  padding: 5rem 5rem;
  background-color: #0E1332;
  text-align: center;
  align-content: center;
}

.benefits-section h2 {
  margin-bottom: 4rem;
  font-family: Bebas;
  color: #fff;
  font-size: 3rem;
}

.skill-grid {
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr))!important;
}

.courses-section {
  padding: 2rem;
  background-color: #121E4A;
}

.courses-section h2 {
  max-width: 71rem;
  margin: 2rem auto 4rem;
  font-family: Bebas;
  color: #fff;
  font-size: 3rem;
}

.courses-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  max-width: 70rem;
  margin: 0 auto 3rem;
}

.course-card {
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #121E4A;
  color: #fff;
  text-align: left;
  cursor: pointer;
  max-width: 16rem;
  display: flex;
  flex-direction: column;
}


.course-card:hover {
  transform: scale(1.1);
  transition: all .5s;
  cursor: pointer;
}

.course-image {
  width: 100%;
  border-radius: 5px;
  border-bottom: 5px solid #f0c57a;
}

.course-details {
  padding: 0.5rem;
  flex: 1;
}

.course-details h4 {
  font-size: 1.25rem;
  margin-bottom: 0.5rem;
}

.course-details p {
  margin-top: 0.8rem;
}

.duration {
  font-size: 0.8rem;
  color: #ffffffb3;
}

.price {
  color: #f0c57a;
}

.enroll-btn {
  padding: 0.5rem 1rem;
  border: none;
  width: 100%;
  background-color: #f0c57a;
  color: #000;
  cursor: pointer;
  font-size: 1.1rem;
  margin-top: 1rem;
}

.ml-2 {
  margin-left: 1rem;
}

.enroll-btn:hover {
  background-color: #aacae7;
}

.view-more-courses-btn {
  padding: 0.6rem 2rem;
  background-color: #f0c57a;
  color: #000;
  border: 1px solid #f0ba7c;
  outline: none;
  border-radius: 0.5rem;
  font-weight: 700;
  font-size: 1.2rem;
  display: block;
  padding: 0.6rem 2rem;
  margin: 0 auto 4rem;
  font-family: 'Gothic';
}

a {
  text-decoration: none;
}

@media screen and (max-width: 850px) {
  .hero-section {
    flex-direction: column;
    gap: 2rem;
  }
  .course-card {
    max-width: initial;
  }
}
@media screen and (max-width: 480px) {
  .benefits-section {
    padding: 5rem 2rem;
  }
}
</style>
